// Copyright © 2021 Move Closer
import { computed, defineComponent, inject } from '@vue/composition-api';
import { useImage } from '../../_abstract';
import { FALLBACK_IMG_BASE64 } from './Image.config';
import { bootstrapImageProps } from './Image.hooks';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const BootstrapImage = defineComponent({
    name: 'BootstrapImage',
    props: bootstrapImageProps,
    emits: ['error', 'load'],
    setup(props, ctx) {
        /**
         * Source for the fallback image (in case of the main image load error).
         */
        const fallbackImage = computed(() => typeof props.fallback === 'string' ? props.fallback : FALLBACK_IMG_BASE64);
        /**
         * Source for the loading image (until the target image loads).
         */
        const loadingImage = computed(() => typeof props.loading === 'string' ? props.loading : FALLBACK_IMG_BASE64);
        const { imgAlt, imgSrc, isLoaded, onError, onLoad } = useImage(props, ctx, fallbackImage.value);
        /**
         * Determine if image should be lazy loaded.
         */
        const globalLazy = inject('lazyImages', true);
        const shouldBeLazy = computed(() => globalLazy && props.isLazy && !isLoaded.value);
        return {
            fallbackImage,
            hasWindow: typeof window !== 'undefined',
            imgAlt,
            imgSrc,
            loadingImage,
            onError,
            onLoad,
            shouldBeLazy
        };
    },
    template: `
    <img v-if="shouldBeLazy" v-lazy="{ src:  hasWindow ? imgSrc : null, error: fallbackImage, loading: loadingImage }"
         v-bind="{ sizes, src: loadingImage, width, height }" :data-srcset="srcset" :alt="imgAlt" class="img">
    <img v-else :src="imgSrc" v-bind="{ srcset, sizes, width, height }" :alt="imgAlt"
         @error="onError" @load="onLoad" class="img">
  `
});
